// extracted by mini-css-extract-plugin
module.exports = {"block":"resetButton-module--block--17QTl","btn":"resetButton-module--btn--3UVo3"};